import { TASK_MEMBER } from "../apiConstant";
import BaseApi from "../baseApi";

class TaskMemberApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  removeAssignee(body) {
    return this.post(`${TASK_MEMBER}/remove`, body);
  }

  assignMember(body) {
    return this.post(`${TASK_MEMBER}/add-all`, body);
  }

  getListMemberTask(id) {
    return this.get(`${TASK_MEMBER}/${id}`);
  }
}
export default TaskMemberApi;
